import dynamic from 'next/dynamic';

const mod = (name) => (m) => m[name];

export const LOADERS = {
  'access-age': dynamic(() => import('Components/widgets/icons/AccessAge').then(mod('AccessAge')), {
    ssr: false,
  }),
  adventure: dynamic(() => import('Components/widgets/icons/Adventure').then(mod('Adventure')), {
    ssr: false,
  }),
  'beginner-sportive': dynamic(
    () => import('Components/widgets/icons/BeginnerSportive').then(mod('BeginnerSportive')),
    { ssr: false },
  ),
  couple: dynamic(() => import('Components/widgets/icons/Couple').then(mod('Couple')), {
    ssr: false,
  }),
  'culture-discovery': dynamic(
    () => import('Components/widgets/icons/CultureDiscovery').then(mod('CultureDiscovery')),
    { ssr: false },
  ),
  digitalTools: dynamic(
    () => import('Components/widgets/icons/DigitalTools').then(mod('DigitalTools')),
    { ssr: false },
  ),
  distance: dynamic(() => import('Components/widgets/icons/Distance').then(mod('Distance')), {
    ssr: false,
  }),
  doNotShakeHands: dynamic(
    () => import('Components/widgets/icons/DoNotShakeHands').then(mod('DoNotShakeHands')),
    { ssr: false },
  ),
  pcrTest: dynamic(() => import('Components/widgets/icons/PCRTest').then(mod('PCRTest')), {
    ssr: false,
  }),
  safeReception: dynamic(
    () => import('Components/widgets/icons/SafeReception').then(mod('SafeReception')),
    { ssr: false },
  ),
  safeRestaurant: dynamic(
    () => import('Components/widgets/icons/SafeRestaurant').then(mod('SafeRestaurant')),
    { ssr: false },
  ),
  safeSpa: dynamic(() => import('Components/widgets/icons/SafeSpa').then(mod('SafeSpa')), {
    ssr: false,
  }),
  temperatureCheck: dynamic(
    () => import('Components/widgets/icons/TemperatureCheck').then(mod('TemperatureCheck')),
    { ssr: false },
  ),
  washHands: dynamic(() => import('Components/widgets/icons/WashHands').then(mod('WashHands')), {
    ssr: false,
  }),
  family: dynamic(() => import('Components/widgets/icons/Family').then(mod('Family')), {
    ssr: false,
  }),
  ClubMedGreatMemberFeedBack: dynamic(
    () =>
      import('Components/widgets/icons/ClubMedGreatMemberFeedBack').then(
        mod('ClubMedGreatMemberFeedBack'),
      ),
    { ssr: false },
  ),
  ac: dynamic(() => import('Components/widgets/icons/Ac').then(mod('Ac')), {
    ssr: false,
  }),
  accessiblebathroom: dynamic(
    () => import('Components/widgets/icons/Accessiblebathroom').then(mod('Accessiblebathroom')),
    { ssr: false },
  ),
  accommodations: dynamic(
    () => import('Components/widgets/icons/Accommodations').then(mod('Accommodations')),
    { ssr: false },
  ),
  actionsAgainstSexualTourism: dynamic(
    () =>
      import('Components/widgets/icons/ActionsAgainstSexualTourism').then(
        mod('ActionsAgainstSexualTourism'),
      ),
    { ssr: false },
  ),
  activities: dynamic(() => import('Components/widgets/icons/Activities').then(mod('Activities')), {
    ssr: false,
  }),
  address: dynamic(() => import('Components/widgets/icons/Address').then(mod('Address')), {
    ssr: false,
  }),
  advanced_skiing: dynamic(
    () => import('Components/widgets/icons/AdvancedSkiing').then(mod('AdvancedSkiing')),
    { ssr: false },
  ),
  aexc: dynamic(() => import('Components/widgets/icons/Aexc').then(mod('Aexc')), {
    ssr: false,
  }),
  agac: dynamic(() => import('Components/widgets/icons/Agac').then(mod('Agac')), {
    ssr: false,
  }),
  ahsc: dynamic(() => import('Components/widgets/icons/Ahsc').then(mod('Ahsc')), {
    ssr: false,
  }),
  albc: dynamic(() => import('Components/widgets/icons/Albc').then(mod('Albc')), {
    ssr: false,
  }),
  albv: dynamic(() => import('Components/widgets/icons/Albv').then(mod('Albv')), {
    ssr: false,
  }),
  alhc: dynamic(() => import('Components/widgets/icons/Alhc').then(mod('Alhc')), {
    ssr: false,
  }),
  allInclusive: dynamic(
    () => import('Components/widgets/icons/AllInclusive').then(mod('AllInclusive')),
    { ssr: false },
  ),
  amenities: dynamic(() => import('Components/widgets/icons/Amenities').then(mod('Amenities')), {
    ssr: false,
  }),
  amenities_laundry: dynamic(
    () => import('Components/widgets/icons/AmenitiesLaundry').then(mod('AmenitiesLaundry')),
    { ssr: false },
  ),
  americanfridge: dynamic(
    () => import('Components/widgets/icons/Americanfridge').then(mod('Americanfridge')),
    { ssr: false },
  ),
  animalProtection: dynamic(
    () => import('Components/widgets/icons/AnimalProtection').then(mod('AnimalProtection')),
    { ssr: false },
  ),
  anjj: dynamic(() => import('Components/widgets/icons/Anjj').then(mod('Anjj')), {
    ssr: false,
  }),
  askQuestions: dynamic(
    () => import('Components/widgets/icons/AskQuestions').then(mod('AskQuestions')),
    {
      ssr: false,
    },
  ),
  aplc: dynamic(() => import('Components/widgets/icons/Aplc').then(mod('Aplc')), {
    ssr: false,
  }),
  app: dynamic(() => import('Components/widgets/icons/App').then(mod('App')), {
    ssr: false,
  }),
  apres_ski: dynamic(() => import('Components/widgets/icons/ApresSki').then(mod('ApresSki')), {
    ssr: false,
  }),
  archery: dynamic(() => import('Components/widgets/icons/Archery').then(mod('Archery')), {
    ssr: false,
  }),
  arpc: dynamic(() => import('Components/widgets/icons/Arpc').then(mod('Arpc')), {
    ssr: false,
  }),
  avoc: dynamic(() => import('Components/widgets/icons/Avoc').then(mod('Avoc')), {
    ssr: false,
  }),
  'baby-bed': dynamic(() => import('Components/widgets/icons/BabyBed').then(mod('BabyBed')), {
    ssr: false,
  }),
  'baby-welcome': dynamic(
    () => import('Components/widgets/icons/BabyWelcome').then(mod('BabyWelcome')),
    { ssr: false },
  ),
  babyBottleHeater: dynamic(
    () => import('Components/widgets/icons/BabyBottleHeater').then(mod('BabyBottleHeater')),
    { ssr: false },
  ),
  babyClub: dynamic(() => import('Components/widgets/icons/BabyClub').then(mod('BabyClub')), {
    ssr: false,
  }),
  babyPowder: dynamic(() => import('Components/widgets/icons/BabyPowder').then(mod('BabyPowder')), {
    ssr: false,
  }),
  babySitting: dynamic(
    () => import('Components/widgets/icons/BabySitting').then(mod('BabySitting')),
    { ssr: false },
  ),
  badminton: dynamic(() => import('Components/widgets/icons/Badminton').then(mod('Badminton')), {
    ssr: false,
  }),
  baggage: dynamic(() => import('Components/widgets/icons/Baggage').then(mod('Baggage')), {
    ssr: false,
  }),
  balc: dynamic(() => import('Components/widgets/icons/Balc').then(mod('Balc')), {
    ssr: false,
  }),
  balcony: dynamic(() => import('Components/widgets/icons/Balcony').then(mod('Balcony')), {
    ssr: false,
  }),
  balconyOrTerrace: dynamic(
    () => import('Components/widgets/icons/BalconyOrTerrace').then(mod('BalconyOrTerrace')),
    { ssr: false },
  ),
  baldaquin: dynamic(() => import('Components/widgets/icons/Baldaquin').then(mod('Baldaquin')), {
    ssr: false,
  }),
  balneotherapy: dynamic(
    () => import('Components/widgets/icons/Balneotherapy').then(mod('Balneotherapy')),
    { ssr: false },
  ),
  barcode: dynamic(() => import('Components/widgets/icons/Barcode').then(mod('Barcode')), {
    ssr: false,
  }),
  barsAndRestaurants: dynamic(
    () => import('Components/widgets/icons/BarsAndRestaurants').then(mod('BarsAndRestaurants')),
    { ssr: false },
  ),
  basketball: dynamic(() => import('Components/widgets/icons/Basketball').then(mod('Basketball')), {
    ssr: false,
  }),
  bathrobe: dynamic(() => import('Components/widgets/icons/Bathrobe').then(mod('Bathrobe')), {
    ssr: false,
  }),
  bathroom: dynamic(() => import('Components/widgets/icons/Bathroom').then(mod('Bathroom')), {
    ssr: false,
  }),
  bathtub: dynamic(() => import('Components/widgets/icons/Bathtub').then(mod('Bathtub')), {
    ssr: false,
  }),
  bathtubshower: dynamic(
    () => import('Components/widgets/icons/Bathtubshower').then(mod('Bathtubshower')),
    { ssr: false },
  ),
  bathtubtoilets: dynamic(
    () => import('Components/widgets/icons/Bathtubtoilets').then(mod('Bathtubtoilets')),
    { ssr: false },
  ),
  beach: dynamic(() => import('Components/widgets/icons/Beach').then(mod('Beach')), {
    ssr: false,
  }),
  beachtowel: dynamic(() => import('Components/widgets/icons/Beachtowel').then(mod('Beachtowel')), {
    ssr: false,
  }),
  'beauty-mirror': dynamic(
    () => import('Components/widgets/icons/BeautyMirror').then(mod('BeautyMirror')),
    { ssr: false },
  ),
  bed: dynamic(() => import('Components/widgets/icons/Bed').then(mod('Bed')), {
    ssr: false,
  }),
  bednight: dynamic(() => import('Components/widgets/icons/Bednight').then(mod('Bednight')), {
    ssr: false,
  }),
  beic: dynamic(() => import('Components/widgets/icons/Beic').then(mod('Beic')), {
    ssr: false,
  }),
  bench: dynamic(() => import('Components/widgets/icons/Bench').then(mod('Bench')), {
    ssr: false,
  }),
  bib: dynamic(() => import('Components/widgets/icons/Bib').then(mod('Bib')), {
    ssr: false,
  }),
  bikeRental: dynamic(() => import('Components/widgets/icons/BikeRental').then(mod('BikeRental')), {
    ssr: false,
  }),
  biodiversity: dynamic(
    () => import('Components/widgets/icons/Biodiversity').then(mod('Biodiversity')),
    { ssr: false },
  ),
  biscuit: dynamic(() => import('Components/widgets/icons/Biscuit').then(mod('Biscuit')), {
    ssr: false,
  }),
  bidet: dynamic(() => import('Components/widgets/icons/Bidet').then(mod('Bidet')), {
    ssr: false,
  }),
  blender: dynamic(() => import('Components/widgets/icons/Blender').then(mod('Blender')), {
    ssr: false,
  }),
  bluetooth: dynamic(() => import('Components/widgets/icons/Bluetooth').then(mod('Bluetooth')), {
    ssr: false,
  }),
  bluetoothspeaker: dynamic(
    () => import('Components/widgets/icons/Bluetoothspeaker').then(mod('Bluetoothspeaker')),
    { ssr: false },
  ),
  boat: dynamic(() => import('Components/widgets/icons/Boat').then(mod('Boat')), {
    ssr: false,
  }),
  bodc: dynamic(() => import('Components/widgets/icons/Bodc').then(mod('Bodc')), {
    ssr: false,
  }),
  byeByePlastic: dynamic(
    () => import('Components/widgets/icons/ByeByePlastic').then(mod('ByeByePlastic')),
    { ssr: false },
  ),
  arrowTop: dynamic(() => import('Components/widgets/icons/ArrowTop').then(mod('ArrowTop')), {
    ssr: false,
  }),
  arrowFilledTop: dynamic(
    () => import('Components/widgets/icons/ArrowFilledTop').then(mod('ArrowFilledTop')),
    {
      ssr: false,
    },
  ),
  arrowOutlineTop: dynamic(
    () => import('Components/widgets/icons/ArrowOutlineTop').then(mod('ArrowOutlineTop')),
    {
      ssr: false,
    },
  ),
  arrowTailTop: dynamic(
    () => import('Components/widgets/icons/ArrowTailTop').then(mod('ArrowTailTop')),
    {
      ssr: false,
    },
  ),
  arrowRight: dynamic(() => import('Components/widgets/icons/ArrowRight').then(mod('ArrowRight')), {
    ssr: false,
  }),
  arrowFilledRight: dynamic(
    () => import('Components/widgets/icons/ArrowFilledRight').then(mod('ArrowFilledRight')),
    { ssr: false },
  ),
  arrowOutlineRight: dynamic(
    () => import('Components/widgets/icons/ArrowOutlineRight').then(mod('ArrowOutlineRight')),
    { ssr: false },
  ),
  arrowTailRight: dynamic(
    () => import('Components/widgets/icons/ArrowTailRight').then(mod('ArrowTailRight')),
    { ssr: false },
  ),
  arrowDown: dynamic(() => import('Components/widgets/icons/ArrowDown').then(mod('ArrowDown')), {
    ssr: false,
  }),
  arrowFilledDown: dynamic(
    () => import('Components/widgets/icons/ArrowFilledDown').then(mod('ArrowFilledDown')),
    { ssr: false },
  ),
  arrowOutlineDown: dynamic(
    () => import('Components/widgets/icons/ArrowOutlineDown').then(mod('ArrowOutlineDown')),
    { ssr: false },
  ),
  arrowTailDown: dynamic(
    () => import('Components/widgets/icons/ArrowTailDown').then(mod('ArrowTailDown')),
    { ssr: false },
  ),
  arrowLeft: dynamic(() => import('Components/widgets/icons/ArrowLeft').then(mod('ArrowLeft')), {
    ssr: false,
  }),
  arrowFilledLeft: dynamic(
    () => import('Components/widgets/icons/ArrowFilledLeft').then(mod('ArrowFilledLeft')),
    { ssr: false },
  ),
  arrowOutlineLeft: dynamic(
    () => import('Components/widgets/icons/ArrowOutlineLeft').then(mod('ArrowOutlineLeft')),
    { ssr: false },
  ),
  arrowTailLeft: dynamic(
    () => import('Components/widgets/icons/ArrowTailLeft').then(mod('ArrowTailLeft')),
    { ssr: false },
  ),
  bottleBrush: dynamic(
    () => import('Components/widgets/icons/BottleBrush').then(mod('BottleBrush')),
    { ssr: false },
  ),
  boutique: dynamic(() => import('Components/widgets/icons/Boutique').then(mod('Boutique')), {
    ssr: false,
  }),
  bowls: dynamic(() => import('Components/widgets/icons/Bowls').then(mod('Bowls')), {
    ssr: false,
  }),
  bucc: dynamic(() => import('Components/widgets/icons/Bucc').then(mod('Bucc')), {
    ssr: false,
  }),
  buggy: dynamic(() => import('Components/widgets/icons/Buggy').then(mod('Buggy')), {
    ssr: false,
  }),
  businessClass: dynamic(
    () => import('Components/widgets/icons/BusinessClass').then(mod('BusinessClass')),
    { ssr: false },
  ),
  canc: dynamic(() => import('Components/widgets/icons/Canc').then(mod('Canc')), {
    ssr: false,
  }),
  cancellation: dynamic(
    () => import('Components/widgets/icons/Cancellation').then(mod('Cancellation')),
    { ssr: false },
  ),
  car: dynamic(() => import('Components/widgets/icons/Car').then(mod('Car')), {
    ssr: false,
  }),
  carc: dynamic(() => import('Components/widgets/icons/Carc').then(mod('Carc')), {
    ssr: false,
  }),
  cardioTraining: dynamic(
    () => import('Components/widgets/icons/CardioTraining').then(mod('CardioTraining')),
    { ssr: false },
  ),
  carpark: dynamic(() => import('Components/widgets/icons/Carpark').then(mod('Carpark')), {
    ssr: false,
  }),
  cbac: dynamic(() => import('Components/widgets/icons/Cbac').then(mod('Cbac')), {
    ssr: false,
  }),
  cd: dynamic(() => import('Components/widgets/icons/Cd').then(mod('Cd')), {
    ssr: false,
  }),
  cddvd: dynamic(() => import('Components/widgets/icons/Cddvd').then(mod('Cddvd')), {
    ssr: false,
  }),
  cerc: dynamic(() => import('Components/widgets/icons/Cerc').then(mod('Cerc')), {
    ssr: false,
  }),
  cfac: dynamic(() => import('Components/widgets/icons/Cfac').then(mod('Cfac')), {
    ssr: false,
  }),
  cgbj: dynamic(() => import('Components/widgets/icons/Cgbj').then(mod('Cgbj')), {
    ssr: false,
  }),
  chac: dynamic(() => import('Components/widgets/icons/Chac').then(mod('Chac')), {
    ssr: false,
  }),
  chairlifts: dynamic(() => import('Components/widgets/icons/Chairlifts').then(mod('Chairlifts')), {
    ssr: false,
  }),
  champagne: dynamic(() => import('Components/widgets/icons/Champagne').then(mod('Champagne')), {
    ssr: false,
  }),
  champagneglass: dynamic(
    () => import('Components/widgets/icons/Champagneglass').then(mod('Champagneglass')),
    { ssr: false },
  ),
  charcuterie: dynamic(
    () => import('Components/widgets/icons/Charcuterie').then(mod('Charcuterie')),
    { ssr: false },
  ),
  changingMat: dynamic(
    () => import('Components/widgets/icons/ChangingMat').then(mod('ChangingMat')),
    { ssr: false },
  ),
  chec: dynamic(() => import('Components/widgets/icons/Chec').then(mod('Chec')), {
    ssr: false,
  }),
  check: dynamic(() => import('Components/widgets/icons/Check').then(mod('Check')), {
    ssr: false,
  }),
  checkboxChecked: dynamic(
    () => import('Components/widgets/icons/CheckboxChecked').then(mod('CheckboxChecked')),
    { ssr: false },
  ),
  checkboxUnchecked: dynamic(
    () => import('Components/widgets/icons/CheckboxUnchecked').then(mod('CheckboxUnchecked')),
    { ssr: false },
  ),
  checkList: dynamic(() => import('Components/widgets/icons/CheckList').then(mod('CheckList')), {
    ssr: false,
  }),
  cheese: dynamic(() => import('Components/widgets/icons/Cheese').then(mod('Cheese')), {
    ssr: false,
  }),
  childcare: dynamic(() => import('Components/widgets/icons/Childcare').then(mod('Childcare')), {
    ssr: false,
  }),
  children: dynamic(() => import('Components/widgets/icons/Children').then(mod('Children')), {
    ssr: false,
  }),
  chrono: dynamic(() => import('Components/widgets/icons/Chrono').then(mod('Chrono')), {
    ssr: false,
  }),
  circledAccommodation: dynamic(
    () => import('Components/widgets/icons/CircledAccommodation').then(mod('CircledAccommodation')),
    { ssr: false },
  ),
  circledPlane: dynamic(
    () => import('Components/widgets/icons/CircledPlane').then(mod('CircledPlane')),
    { ssr: false },
  ),
  circledRightArrow: dynamic(
    () => import('Components/widgets/icons/CircledRightArrow').then(mod('CircledRightArrow')),
    { ssr: false },
  ),
  tour: dynamic(() => import('Components/widgets/icons/Tour').then(mod('Tour')), {
    ssr: false,
  }),
  climateAction: dynamic(
    () => import('Components/widgets/icons/ClimateActions').then(mod('ClimateActions')),
    { ssr: false },
  ),
  climbing: dynamic(() => import('Components/widgets/icons/Climbing').then(mod('Climbing')), {
    ssr: false,
  }),
  closedEyePassword: dynamic(
    () => import('Components/widgets/icons/ClosedEyePassword').then(mod('ClosedEyePassword')),
    { ssr: false },
  ),
  ClubMedEasyArrivalConfirmation: dynamic(() =>
    import('Components/widgets/icons/ClubMedEasyArrivalConfirmation').then(
      mod('ClubMedEasyArrivalConfirmation'),
    ),
  ),
  clubMedGreatMembersIntro: dynamic(
    () =>
      import('Components/widgets/icons/ClubMedGreatMembersIntro').then(
        mod('ClubMedGreatMembersIntro'),
      ),
    { ssr: false },
  ),
  clubmed: dynamic(() => import('Components/widgets/icons/Clubmed').then(mod('Clubmed')), {
    ssr: true,
  }),
  clubmedAllInclusiveLarge: dynamic(
    () =>
      import('Components/widgets/icons/ClubmedAllInclusiveLarge').then(
        mod('ClubmedAllInclusiveLarge'),
      ),
    { ssr: false },
  ),
  clubmedAllInclusiveSmall: dynamic(
    () =>
      import('Components/widgets/icons/ClubmedAllInclusiveSmall').then(
        mod('ClubmedAllInclusiveSmall'),
      ),
    { ssr: false },
  ),
  clubmedGM: dynamic(() => import('Components/widgets/icons/ClubmedGm').then(mod('ClubmedGm')), {
    ssr: false,
  }),
  clubmedJobs: dynamic(
    () => import('Components/widgets/icons/ClubmedJobs').then(mod('ClubmedJobs')),
    { ssr: false },
  ),
  clubmedJoyView: dynamic(
    () => import('Components/widgets/icons/ClubmedJoyView').then(mod('ClubmedJoyView')),
    { ssr: false },
  ),
  clubmedMeetings: dynamic(
    () => import('Components/widgets/icons/ClubmedMeetings').then(mod('ClubmedMeetings')),
    { ssr: true },
  ),
  clubmedPlus: dynamic(
    () => import('Components/widgets/icons/ClubmedPlus').then(mod('ClubmedPlus')),
    { ssr: false },
  ),
  clubmedProperty: dynamic(
    () => import('Components/widgets/icons/ClubmedProperty').then(mod('ClubmedProperty')),
    { ssr: false },
  ),
  clubmedTravelAgents: dynamic(
    () => import('Components/widgets/icons/ClubmedTravelAgents').then(mod('ClubmedTravelAgents')),
    { ssr: false },
  ),
  cm2c: dynamic(() => import('Components/widgets/icons/Cm2c').then(mod('Cm2c')), {
    ssr: false,
  }),
  cocoaPowder: dynamic(
    () => import('Components/widgets/icons/CocoaPowder').then(mod('CocoaPowder')),
    { ssr: false },
  ),
  coffeemaker: dynamic(
    () => import('Components/widgets/icons/Coffeemaker').then(mod('Coffeemaker')),
    { ssr: false },
  ),
  colc: dynamic(() => import('Components/widgets/icons/Colc').then(mod('Colc')), {
    ssr: false,
  }),
  coldDrinks: dynamic(() => import('Components/widgets/icons/ColdDrinks').then(mod('ColdDrinks')), {
    ssr: false,
  }),
  coldSandwich: dynamic(
    () => import('Components/widgets/icons/ColdSandwich').then(mod('ColdSandwich')),
    { ssr: false },
  ),
  compare: dynamic(() => import('Components/widgets/icons/Compare').then(mod('Compare')), {
    ssr: false,
  }),
  compass: dynamic(() => import('Components/widgets/icons/Compass').then(mod('Compass')), {
    ssr: false,
  }),
  confetti: dynamic(() => import('Components/widgets/icons/Confetti').then(mod('Confetti'))),
  confettiAlone: dynamic(() =>
    import('Components/widgets/icons/ConfettiAlone').then(mod('ConfettiAlone')),
  ),
  confettiColored: dynamic(() =>
    import('Components/widgets/icons/ConfettiColored').then(mod('ConfettiColored')),
  ),
  confettiSuccess: dynamic(() =>
    import('Components/widgets/icons/ConfettiSuccess').then(mod('ConfettiSuccess')),
  ),
  confettiSuccessBg: dynamic(() =>
    import('Components/widgets/icons/ConfettiSuccessBg').then(mod('ConfettiSuccessBg')),
  ),
  connect: dynamic(() => import('Components/widgets/icons/Connect').then(mod('Connect')), {
    ssr: false,
  }),
  connecting: dynamic(() => import('Components/widgets/icons/Connecting').then(mod('Connecting')), {
    ssr: false,
  }),
  'connection-information': dynamic(
    () =>
      import('Components/widgets/icons/ConnectionInformation').then(mod('ConnectionInformation')),
    { ssr: false },
  ),
  contact: dynamic(() => import('Components/widgets/icons/Contact').then(mod('Contact')), {
    ssr: false,
  }),
  copy_link: dynamic(() => import('Components/widgets/icons/CopyLink').then(mod('CopyLink')), {
    ssr: false,
  }),
  creactive: dynamic(() => import('Components/widgets/icons/Creactive').then(mod('Creactive')), {
    ssr: false,
  }),
  creditcard: dynamic(() => import('Components/widgets/icons/Creditcard').then(mod('Creditcard')), {
    ssr: false,
  }),
  crgc: dynamic(() => import('Components/widgets/icons/Crgc').then(mod('Crgc')), {
    ssr: false,
  }),
  cross: dynamic(() => import('Components/widgets/icons/Cross').then(mod('Cross')), {
    ssr: false,
  }),
  crossFilled: dynamic(
    () => import('Components/widgets/icons/CrossFilled').then(mod('CrossFilled')),
    { ssr: false },
  ),
  crossOutline: dynamic(
    () => import('Components/widgets/icons/CrossOutline').then(mod('CrossOutline')),
    { ssr: false },
  ),
  cruise: dynamic(() => import('Components/widgets/icons/Cruise').then(mod('Cruise')), {
    ssr: false,
  }),
  cskc: dynamic(() => import('Components/widgets/icons/Cskc').then(mod('Cskc')), {
    ssr: false,
  }),
  culturalRespect: dynamic(
    () => import('Components/widgets/icons/CulturalRespect').then(mod('CulturalRespect')),
    { ssr: false },
  ),
  dalc: dynamic(() => import('Components/widgets/icons/Dalc').then(mod('Dalc')), {
    ssr: false,
  }),
  dance: dynamic(() => import('Components/widgets/icons/Dance').then(mod('Dance')), {
    ssr: false,
  }),
  daoc: dynamic(() => import('Components/widgets/icons/Daoc').then(mod('Daoc')), {
    ssr: false,
  }),
  date: dynamic(() => import('Components/widgets/icons/Date').then(mod('Date')), {
    ssr: false,
  }),
  datePlus: dynamic(() => import('Components/widgets/icons/DatePlus').then(mod('DatePlus')), {
    ssr: false,
  }),
  dateStar: dynamic(() => import('Components/widgets/icons/DateStar').then(mod('DateStar')), {
    ssr: false,
  }),
  daybed: dynamic(() => import('Components/widgets/icons/Daybed').then(mod('Daybed')), {
    ssr: false,
  }),
  dbac: dynamic(() => import('Components/widgets/icons/Dbac').then(mod('Dbac')), {
    ssr: false,
  }),
  ddoc: dynamic(() => import('Components/widgets/icons/Ddoc').then(mod('Ddoc')), {
    ssr: false,
  }),
  dedicated: dynamic(() => import('Components/widgets/icons/Dedicated').then(mod('Dedicated')), {
    ssr: false,
  }),
  dessert: dynamic(() => import('Components/widgets/icons/Dessert').then(mod('Dessert')), {
    ssr: false,
  }),
  destination: dynamic(
    () => import('Components/widgets/icons/Destination').then(mod('Destination')),
    { ssr: false },
  ),
  details: dynamic(() => import('Components/widgets/icons/Details').then(mod('Details')), {
    ssr: false,
  }),
  diamond: dynamic(() => import('Components/widgets/icons/Diamond').then(mod('Diamond'))),
  digital_EC: dynamic(() => import('Components/widgets/icons/DigitalEC').then(mod('DigitalEC')), {
    ssr: false,
  }),
  'dining-room': dynamic(
    () => import('Components/widgets/icons/DiningRoom').then(mod('DiningRoom')),
    { ssr: false },
  ),
  disconnection: dynamic(
    () => import('Components/widgets/icons/Disconnection').then(mod('Disconnection')),
    { ssr: false },
  ),
  'discovery-center': dynamic(
    () => import('Components/widgets/icons/DiscoveryCenter').then(mod('DiscoveryCenter')),
    { ssr: false },
  ),
  dishes: dynamic(() => import('Components/widgets/icons/Dishes').then(mod('Dishes')), {
    ssr: false,
  }),
  dishwasher: dynamic(() => import('Components/widgets/icons/Dishwasher').then(mod('Dishwasher')), {
    ssr: false,
  }),
  disinfection: dynamic(
    () => import('Components/widgets/icons/Disinfection').then(mod('Disinfection')),
    { ssr: false },
  ),
  disinfectionBis: dynamic(
    () => import('Components/widgets/icons/DisinfectionBis').then(mod('DisinfectionBis')),
    { ssr: false },
  ),
  disposableSilverware: dynamic(
    () => import('Components/widgets/icons/DisposableSilverware').then(mod('DisposableSilverware')),
    { ssr: false },
  ),
  distancing: dynamic(() => import('Components/widgets/icons/Distancing').then(mod('Distancing')), {
    ssr: false,
  }),
  diving: dynamic(() => import('Components/widgets/icons/Diving').then(mod('Diving')), {
    ssr: false,
  }),
  dmd_club: dynamic(() => import('Components/widgets/icons/DmdClub').then(mod('DmdClub')), {
    ssr: false,
  }),
  dmd_deluxe: dynamic(() => import('Components/widgets/icons/DmdDeluxe').then(mod('DmdDeluxe')), {
    ssr: false,
  }),
  dmd_suite: dynamic(() => import('Components/widgets/icons/DmdSuite').then(mod('DmdSuite')), {
    ssr: false,
  }),
  dmd_superior: dynamic(
    () => import('Components/widgets/icons/DmdSuperior').then(mod('DmdSuperior')),
    { ssr: false },
  ),
  document: dynamic(() => import('Components/widgets/icons/Document').then(mod('Document')), {
    ssr: false,
  }),
  documentColored: dynamic(
    () => import('Components/widgets/icons/DocumentColored').then(mod('DocumentColored')),
    { ssr: false },
  ),
  donation: dynamic(() => import('Components/widgets/icons/Donation').then(mod('Donation')), {
    ssr: false,
  }),
  doorhanger: dynamic(() => import('Components/widgets/icons/Doorhanger').then(mod('Doorhanger')), {
    ssr: false,
  }),
  'double-balcony': dynamic(
    () => import('Components/widgets/icons/DoubleBalcony').then(mod('DoubleBalcony')),
    { ssr: false },
  ),
  download: dynamic(() => import('Components/widgets/icons/Download').then(mod('Download')), {
    ssr: false,
  }),
  doctor: dynamic(() => import('Components/widgets/icons/Doctor').then(mod('Doctor')), {
    ssr: false,
  }),
  dresscode: dynamic(() => import('Components/widgets/icons/Dresscode').then(mod('Dresscode')), {
    ssr: false,
  }),
  dressing: dynamic(() => import('Components/widgets/icons/Dressing').then(mod('Dressing')), {
    ssr: false,
  }),
  dressingtable: dynamic(
    () => import('Components/widgets/icons/Dressingtable').then(mod('Dressingtable')),
    { ssr: false },
  ),
  dryer: dynamic(() => import('Components/widgets/icons/Dryer').then(mod('Dryer')), {
    ssr: false,
  }),
  dualbathroom: dynamic(
    () => import('Components/widgets/icons/Dualbathroom').then(mod('Dualbathroom')),
    { ssr: false },
  ),
  dualcabin: dynamic(() => import('Components/widgets/icons/Dualcabin').then(mod('Dualcabin')), {
    ssr: false,
  }),
  duration: dynamic(() => import('Components/widgets/icons/Duration').then(mod('Duration')), {
    ssr: false,
  }),
  dvd: dynamic(() => import('Components/widgets/icons/Dvd').then(mod('Dvd')), {
    ssr: false,
  }),
  earth: dynamic(() => import('Components/widgets/icons/Earth').then(mod('Earth')), {
    ssr: false,
  }),
  earthPlane: dynamic(() => import('Components/widgets/icons/EarthPlane').then(mod('EarthPlane')), {
    ssr: false,
  }),
  easyArrivalTitle: dynamic(
    () => import('Components/widgets/icons/EasyArrivalTitle').then(mod('EasyArrivalTitle')),
    { ssr: false },
  ),
  electricity: dynamic(
    () => import('Components/widgets/icons/Electricity').then(mod('Electricity')),
    { ssr: false },
  ),
  electricityManagement: dynamic(
    () =>
      import('Components/widgets/icons/ElectricityManagement').then(mod('ElectricityManagement')),
    { ssr: false },
  ),
  enjoy: dynamic(() => import('Components/widgets/icons/Enjoy').then(mod('Enjoy')), {
    ssr: false,
  }),
  entertainment: dynamic(
    () => import('Components/widgets/icons/Entertainment').then(mod('Entertainment')),
    { ssr: false },
  ),
  environmentProtection: dynamic(
    () =>
      import('Components/widgets/icons/EnvironmentProtection').then(mod('EnvironmentProtection')),
    { ssr: false },
  ),
  equalOpportunities: dynamic(
    () => import('Components/widgets/icons/EqualOpportunities').then(mod('EqualOpportunities')),
    { ssr: false },
  ),
  espresso: dynamic(() => import('Components/widgets/icons/Espresso').then(mod('Espresso')), {
    ssr: false,
  }),
  exclamationPoint: dynamic(
    () => import('Components/widgets/icons/ExclamationPoint').then(mod('ExclamationPoint')),
    {
      ssr: false,
    },
  ),
  exclusiveCollection: dynamic(
    () => import('Components/widgets/icons/ExclusiveCollection').then(mod('ExclusiveCollection')),
    { ssr: false },
  ),
  eyePassword: dynamic(
    () => import('Components/widgets/icons/EyePassword').then(mod('EyePassword')),
    { ssr: false },
  ),
  facebook: dynamic(() => import('Components/widgets/icons/Facebook').then(mod('Facebook')), {
    ssr: false,
  }),
  twitter: dynamic(() => import('Components/widgets/icons/Twitter').then(mod('Twitter')), {
    ssr: false,
  }),
  pinterest: dynamic(() => import('Components/widgets/icons/Pinterest').then(mod('Pinterest')), {
    ssr: false,
  }),
  fan: dynamic(() => import('Components/widgets/icons/Fan').then(mod('Fan')), {
    ssr: false,
  }),
  farmersProgram: dynamic(
    () => import('Components/widgets/icons/FarmersProgram').then(mod('FarmersProgram')),
    { ssr: false },
  ),
  fatDot: dynamic(() => import('Components/widgets/icons/FatDot').then(mod('FatDot')), {
    ssr: false,
  }),
  'fir-tree-view': dynamic(
    () => import('Components/widgets/icons/FirTreeView').then(mod('FirTreeView')),
    { ssr: false },
  ),
  fireplace: dynamic(() => import('Components/widgets/icons/FirePlace').then(mod('FirePlace')), {
    ssr: false,
  }),
  fitness: dynamic(() => import('Components/widgets/icons/Fitness').then(mod('Fitness')), {
    ssr: false,
  }),
  flexible: dynamic(() => import('Components/widgets/icons/Flexible').then(mod('Flexible')), {
    ssr: false,
  }),
  floorPlan: dynamic(() => import('Components/widgets/icons/FloorPlan').then(mod('FloorPlan')), {
    ssr: false,
  }),
  folder: dynamic(() => import('Components/widgets/icons/Folder').then(mod('Folder')), {
    ssr: false,
  }),
  football: dynamic(() => import('Components/widgets/icons/Football').then(mod('Football')), {
    ssr: false,
  }),
  oney_4x: dynamic(() => import('Components/widgets/icons/FourTimesOney').then(mod('FourXOney')), {
    ssr: false,
  }),
  fridge: dynamic(() => import('Components/widgets/icons/Fridge').then(mod('Fridge')), {
    ssr: false,
  }),
  fruitBasket: dynamic(
    () => import('Components/widgets/icons/FruitBasket').then(mod('FruitBasket')),
    { ssr: false },
  ),
  fruitJuice: dynamic(() => import('Components/widgets/icons/FruitJuice').then(mod('FruitJuice')), {
    ssr: false,
  }),
  expand: dynamic(() => import('Components/widgets/icons/Expand').then(mod('Expand')), {
    ssr: false,
  }),
  reduce: dynamic(() => import('Components/widgets/icons/Reduce').then(mod('Reduce')), {
    ssr: false,
  }),
  'furnished-terrace': dynamic(
    () => import('Components/widgets/icons/FurnishedTerrace').then(mod('FurnishedTerrace')),
    { ssr: false },
  ),
  garden_side: dynamic(
    () => import('Components/widgets/icons/GardenSide').then(mod('GardenSide')),
    { ssr: false },
  ),
  garden_view: dynamic(
    () => import('Components/widgets/icons/GardenView').then(mod('GardenView')),
    { ssr: false },
  ),
  gloves: dynamic(() => import('Components/widgets/icons/Gloves').then(mod('Gloves')), {
    ssr: false,
  }),
  gmac: dynamic(() => import('Components/widgets/icons/Gmac').then(mod('Gmac')), {
    ssr: false,
  }),
  gmav: dynamic(() => import('Components/widgets/icons/Gmav').then(mod('Gmav')), {
    ssr: false,
  }),
  'golf-view': dynamic(() => import('Components/widgets/icons/GolfView').then(mod('GolfView')), {
    ssr: false,
  }),
  golf: dynamic(() => import('Components/widgets/icons/Golf').then(mod('Golf')), {
    ssr: false,
  }),
  gourmetLounge: dynamic(
    () => import('Components/widgets/icons/GourmetLounge').then(mod('GourmetLounge')),
    { ssr: false },
  ),
  grec: dynamic(() => import('Components/widgets/icons/Grec').then(mod('Grec')), {
    ssr: false,
  }),
  grounds: dynamic(() => import('Components/widgets/icons/Grounds').then(mod('Grounds')), {
    ssr: false,
  }),
  grwj: dynamic(() => import('Components/widgets/icons/Grwj').then(mod('Grwj')), {
    ssr: false,
  }),
  guaranteedPrice: dynamic(
    () => import('Components/widgets/icons/GuaranteedPrice').then(mod('GuaranteedPrice')),
    {
      ssr: false,
    },
  ),
  guic: dynamic(() => import('Components/widgets/icons/Guic').then(mod('Guic')), {
    ssr: false,
  }),
  handsShake: dynamic(() => import('Components/widgets/icons/HandsShake').then(mod('HandsShake')), {
    ssr: false,
  }),
  hairdresser: dynamic(
    () => import('Components/widgets/icons/Hairdresser').then(mod('Hairdresser')),
    { ssr: false },
  ),
  hairdryer: dynamic(() => import('Components/widgets/icons/Hairdryer').then(mod('Hairdryer')), {
    ssr: false,
  }),
  healthyCorner: dynamic(
    () => import('Components/widgets/icons/HealthyCorner').then(mod('HealthyCorner')),
    { ssr: false },
  ),
  hltj: dynamic(() => import('Components/widgets/icons/Hltj').then(mod('Hltj')), {
    ssr: false,
  }),
  menu: dynamic(() => import('Components/widgets/icons/Menu').then(mod('Menu')), {
    ssr: false,
  }),
  hammam: dynamic(() => import('Components/widgets/icons/Hammam').then(mod('Hammam')), {
    ssr: false,
  }),
  happyArrival: dynamic(
    () => import('Components/widgets/icons/HappyArrival').then(mod('HappyArrival')),
    { ssr: false },
  ),
  happyToCare: dynamic(
    () => import('Components/widgets/icons/HappyToCare').then(mod('HappyToCare')),
    {
      ssr: false,
    },
  ),
  happyToCareText: dynamic(
    () => import('Components/widgets/icons/HappyToCareText').then(mod('HappyToCareText')),
    {
      ssr: false,
    },
  ),
  promotionHappyFirst: dynamic(
    () => import('Components/widgets/icons/PromotionHappyFirst').then(mod('PromotionHappyFirst')),
    { ssr: false },
  ),
  health: dynamic(() => import('Components/widgets/icons/Health').then(mod('Health')), {
    ssr: false,
  }),
  heart: dynamic(() => import('Components/widgets/icons/Heart').then(mod('Heart')), {
    ssr: false,
  }),
  heartFilled: dynamic(
    () => import('Components/widgets/icons/HeartFilled').then(mod('HeartFilled')),
    { ssr: false },
  ),
  home: dynamic(() => import('Components/widgets/icons/Home').then(mod('Home')), {
    ssr: false,
  }),
  homecinema: dynamic(() => import('Components/widgets/icons/Homecinema').then(mod('Homecinema')), {
    ssr: false,
  }),
  hotDrinks: dynamic(() => import('Components/widgets/icons/HotDrinks').then(mod('HotDrinks')), {
    ssr: false,
  }),
  hotSandwiches: dynamic(
    () => import('Components/widgets/icons/HotSandwiches').then(mod('HotSandwiches')),
    { ssr: false },
  ),
  household: dynamic(() => import('Components/widgets/icons/Household').then(mod('Household')), {
    ssr: false,
  }),
  icebucket: dynamic(() => import('Components/widgets/icons/Icebucket').then(mod('Icebucket')), {
    ssr: false,
  }),
  icemaker: dynamic(() => import('Components/widgets/icons/Icemaker').then(mod('Icemaker')), {
    ssr: false,
  }),
  iceSkating: dynamic(() => import('Components/widgets/icons/IceSkating').then(mod('IceSkating')), {
    ssr: false,
  }),
  idealForFamily: dynamic(
    () => import('Components/widgets/icons/IdealForFamily').then(mod('IdealForFamily')),
    { ssr: false },
  ),
  induction: dynamic(() => import('Components/widgets/icons/Induction').then(mod('Induction')), {
    ssr: false,
  }),
  information: dynamic(
    () => import('Components/widgets/icons/Information').then(mod('Information')),
    { ssr: false },
  ),
  informationFilled: dynamic(
    () => import('Components/widgets/icons/InformationFilled').then(mod('InformationFilled')),
    { ssr: false },
  ),
  instagram: dynamic(() => import('Components/widgets/icons/Instagram').then(mod('Instagram')), {
    ssr: false,
  }),
  insurance: dynamic(() => import('Components/widgets/icons/Insurance').then(mod('Insurance')), {
    ssr: false,
  }),
  insuranceCancellation: dynamic(
    () =>
      import('Components/widgets/icons/InsuranceCancellation').then(mod('InsuranceCancellation')),
    { ssr: false },
  ),
  internet: dynamic(() => import('Components/widgets/icons/Internet').then(mod('Internet')), {
    ssr: false,
  }),
  ipoddock: dynamic(() => import('Components/widgets/icons/Ipoddock').then(mod('Ipoddock')), {
    ssr: false,
  }),
  ironing: dynamic(() => import('Components/widgets/icons/Ironing').then(mod('Ironing')), {
    ssr: false,
  }),
  itac: dynamic(() => import('Components/widgets/icons/Itac').then(mod('Itac')), {
    ssr: false,
  }),
  ixtc: dynamic(() => import('Components/widgets/icons/Ixtc').then(mod('Ixtc')), {
    ssr: false,
  }),
  juicer: dynamic(() => import('Components/widgets/icons/Juicer').then(mod('Juicer')), {
    ssr: false,
  }),
  junior: dynamic(() => import('Components/widgets/icons/Junior').then(mod('Junior')), {
    ssr: false,
  }),
  kabc: dynamic(() => import('Components/widgets/icons/Kabc').then(mod('Kabc')), {
    ssr: false,
  }),
  kahc: dynamic(() => import('Components/widgets/icons/Kahc').then(mod('Kahc')), {
    ssr: false,
  }),
  kamc: dynamic(() => import('Components/widgets/icons/Kamc').then(mod('Kamc')), {
    ssr: false,
  }),
  kanc: dynamic(() => import('Components/widgets/icons/Kanc').then(mod('Kanc')), {
    ssr: false,
  }),
  kanv: dynamic(() => import('Components/widgets/icons/Kanv').then(mod('Kanv')), {
    ssr: false,
  }),
  kayak: dynamic(() => import('Components/widgets/icons/Kayak').then(mod('Kayak')), {
    ssr: false,
  }),
  kemc: dynamic(() => import('Components/widgets/icons/Kemc').then(mod('Kemc')), {
    ssr: false,
  }),
  kettle: dynamic(() => import('Components/widgets/icons/Kettle').then(mod('Kettle')), {
    ssr: false,
  }),
  keys: dynamic(() => import('Components/widgets/icons/Keys').then(mod('Keys')), {
    ssr: false,
  }),
  'kids-sleeping-area': dynamic(
    () => import('Components/widgets/icons/KidsSleepingArea').then(mod('KidsSleepingArea')),
    { ssr: false },
  ),
  kigc: dynamic(() => import('Components/widgets/icons/Kigc').then(mod('Kigc')), {
    ssr: false,
  }),
  kipc: dynamic(() => import('Components/widgets/icons/Kipc').then(mod('Kipc')), {
    ssr: false,
  }),
  kitchen: dynamic(() => import('Components/widgets/icons/Kitchen').then(mod('Kitchen')), {
    ssr: false,
  }),
  kitchenstorage: dynamic(
    () => import('Components/widgets/icons/Kitchenstorage').then(mod('Kitchenstorage')),
    { ssr: false },
  ),
  kitchenware: dynamic(
    () => import('Components/widgets/icons/Kitchenware').then(mod('Kitchenware')),
    { ssr: false },
  ),
  kitesurf: dynamic(() => import('Components/widgets/icons/Kitesurf').then(mod('Kitesurf')), {
    ssr: false,
  }),
  lakeside: dynamic(() => import('Components/widgets/icons/Lakeside').then(mod('Lakeside')), {
    ssr: false,
  }),
  lakj: dynamic(() => import('Components/widgets/icons/Lakj').then(mod('Lakj')), {
    ssr: false,
  }),
  landing: dynamic(() => import('Components/widgets/icons/Landing').then(mod('Landing')), {
    ssr: false,
  }),
  lapc: dynamic(() => import('Components/widgets/icons/Lapc').then(mod('Lapc')), {
    ssr: false,
  }),
  largestChoice: dynamic(
    () => import('Components/widgets/icons/LargestChoice').then(mod('LargestChoice')),
    {
      ssr: false,
    },
  ),
  laundry: dynamic(() => import('Components/widgets/icons/Laundry').then(mod('Laundry')), {
    ssr: false,
  }),
  'le-45': dynamic(() => import('Components/widgets/icons/Svg45').then(mod('Svg45')), {
    ssr: false,
  }),
  leisure_and_relaxation: dynamic(
    () => import('Components/widgets/icons/LeisureAndRelaxation').then(mod('LeisureAndRelaxation')),
    { ssr: false },
  ),
  level: dynamic(() => import('Components/widgets/icons/Level').then(mod('Level')), {
    ssr: false,
  }),
  lightbulb: dynamic(() => import('Components/widgets/icons/Lightbulb').then(mod('Lightbulb')), {
    ssr: false,
  }),
  lotion: dynamic(() => import('Components/widgets/icons/Lotion').then(mod('Lotion')), {
    ssr: false,
  }),
  list: dynamic(() => import('Components/widgets/icons/List').then(mod('List')), {
    ssr: false,
  }),
  ljic: dynamic(() => import('Components/widgets/icons/Ljic').then(mod('Ljic')), {
    ssr: false,
  }),
  localChildrenWelcome: dynamic(
    () => import('Components/widgets/icons/LocalChildrenWelcome').then(mod('LocalChildrenWelcome')),
    { ssr: false },
  ),
  localDevelopment: dynamic(
    () => import('Components/widgets/icons/LocalDevelopment').then(mod('LocalDevelopment')),
    { ssr: false },
  ),
  localSportSchool: dynamic(
    () => import('Components/widgets/icons/LocalSportSchool').then(mod('LocalSportSchool')),
    { ssr: false },
  ),
  'lounge-area': dynamic(
    () => import('Components/widgets/icons/LoungeArea').then(mod('LoungeArea')),
    { ssr: false },
  ),
  lpac: dynamic(() => import('Components/widgets/icons/Lpac').then(mod('Lpac')), {
    ssr: false,
  }),
  lroc: dynamic(() => import('Components/widgets/icons/Lroc').then(mod('Lroc')), {
    ssr: false,
  }),
  luggage: dynamic(() => import('Components/widgets/icons/Luggage').then(mod('Luggage')), {
    ssr: false,
  }),
  lunch: dynamic(() => import('Components/widgets/icons/Lunch').then(mod('Lunch')), {
    ssr: false,
  }),
  magnifyingGlass: dynamic(
    () => import('Components/widgets/icons/MagnifyingGlass').then(mod('MagnifyingGlass')),
    { ssr: false },
  ),
  mail: dynamic(() => import('Components/widgets/icons/Mail').then(mod('Mail')), {
    ssr: false,
  }),
  manage: dynamic(() => import('Components/widgets/icons/Manage').then(mod('Manage')), {
    ssr: false,
  }),
  manc: dynamic(() => import('Components/widgets/icons/Manc').then(mod('Manc')), {
    ssr: false,
  }),
  manualJuicer: dynamic(
    () => import('Components/widgets/icons/ManualJuicer').then(mod('ManualJuicer')),
    { ssr: false },
  ),
  map_rotate_left: dynamic(
    () => import('Components/widgets/icons/MapRotateLeft').then(mod('MapRotateLeft')),
    { ssr: false },
  ),
  map_rotate_right: dynamic(
    () => import('Components/widgets/icons/MapRotateRight').then(mod('MapRotateRight')),
    { ssr: false },
  ),
  mask: dynamic(() => import('Components/widgets/icons/Mask').then(mod('Mask')), {
    ssr: false,
  }),
  materialDonations: dynamic(
    () => import('Components/widgets/icons/MaterialDonations').then(mod('MaterialDonations')),
    { ssr: false },
  ),
  mauc: dynamic(() => import('Components/widgets/icons/Mauc').then(mod('Mauc')), {
    ssr: false,
  }),
  mchc: dynamic(() => import('Components/widgets/icons/Mchc').then(mod('Mchc')), {
    ssr: false,
  }),
  meal: dynamic(() => import('Components/widgets/icons/Meal').then(mod('Meal')), {
    ssr: false,
  }),
  meat: dynamic(() => import('Components/widgets/icons/Meat').then(mod('Meat')), {
    ssr: false,
  }),
  medicalAssistance: dynamic(
    () => import('Components/widgets/icons/MedicalAssistance').then(mod('MedicalAssistance')),
    { ssr: false },
  ),
  meetingsevents: dynamic(
    () => import('Components/widgets/icons/Meetingsevents').then(mod('Meetingsevents')),
    { ssr: false },
  ),
  microwave: dynamic(() => import('Components/widgets/icons/Microwave').then(mod('Microwave')), {
    ssr: false,
  }),
  microwaveDishes: dynamic(
    () => import('Components/widgets/icons/MicrowaveDishes').then(mod('MicrowaveDishes')),
    { ssr: false },
  ),
  miniClub: dynamic(() => import('Components/widgets/icons/MiniClub').then(mod('MiniClub')), {
    ssr: false,
  }),
  miniClubPlus: dynamic(
    () => import('Components/widgets/icons/MiniClubPlus').then(mod('MiniClubPlus')),
    {
      ssr: false,
    },
  ),
  minifridge: dynamic(() => import('Components/widgets/icons/Minifridge').then(mod('Minifridge')), {
    ssr: false,
  }),
  minus: dynamic(() => import('Components/widgets/icons/Minus').then(mod('Minus')), {
    ssr: false,
  }),
  minusFilled: dynamic(
    () => import('Components/widgets/icons/MinusFilled').then(mod('MinusFilled')),
    {
      ssr: false,
    },
  ),
  minusOutline: dynamic(
    () => import('Components/widgets/icons/MinusOutline').then(mod('MinusOutline')),
    {
      ssr: false,
    },
  ),
  mmac: dynamic(() => import('Components/widgets/icons/Mmac').then(mod('Mmac')), {
    ssr: false,
  }),
  smartphone: dynamic(() => import('Components/widgets/icons/Smartphone').then(mod('Smartphone')), {
    ssr: false,
  }),
  SMS: dynamic(() => import('Components/widgets/icons/SMS').then(mod('SMS')), {
    ssr: false,
  }),
  mosquitos: dynamic(() => import('Components/widgets/icons/Mosquitos').then(mod('Mosquitos')), {
    ssr: false,
  }),
  'mountain-diner': dynamic(
    () => import('Components/widgets/icons/MountainDiner').then(mod('MountainDiner')),
    { ssr: false },
  ),
  'mountain-view': dynamic(
    () => import('Components/widgets/icons/MountainView').then(mod('MountainView')),
    { ssr: false },
  ),
  mpac: dynamic(() => import('Components/widgets/icons/Mpac').then(mod('Mpac')), {
    ssr: false,
  }),
  mpec: dynamic(() => import('Components/widgets/icons/Mpec').then(mod('Mpec')), {
    ssr: false,
  }),
  multipleCompanies: dynamic(
    () => import('Components/widgets/icons/MultipleCompanies').then(mod('MultipleCompanies')),
    { ssr: false },
  ),
  musculation: dynamic(
    () => import('Components/widgets/icons/Musculation').then(mod('Musculation')),
    { ssr: false },
  ),
  musicclock: dynamic(() => import('Components/widgets/icons/Musicclock').then(mod('Musicclock')), {
    ssr: false,
  }),
  'mustTryExperiences-fr': dynamic(
    () => import('Components/widgets/icons/MustTryExperiencesFr').then(mod('MustTryExperiencesFr')),
    { ssr: false },
  ),
  mustTryExperiences: dynamic(
    () => import('Components/widgets/icons/MustTryExperiences').then(mod('MustTryExperiences')),
    { ssr: false },
  ),
  napc: dynamic(() => import('Components/widgets/icons/Napc').then(mod('Napc')), {
    ssr: false,
  }),
  nature: dynamic(() => import('Components/widgets/icons/Nature').then(mod('Nature')), {
    ssr: false,
  }),
  new: dynamic(() => import('Components/widgets/icons/New').then(mod('New')), {
    ssr: false,
  }),
  needle: dynamic(() => import('Components/widgets/icons/Needle').then(mod('Needle')), {
    ssr: false,
  }),
  noAccommodation: dynamic(
    () => import('Components/widgets/icons/NoAccommodation').then(mod('NoAccommodation')),
    {
      ssr: false,
    },
  ),
  noStop: dynamic(() => import('Components/widgets/icons/NoStop').then(mod('NoStop')), {
    ssr: false,
  }),
  noTransfer: dynamic(() => import('Components/widgets/icons/NoTransfer').then(mod('NoTransfer')), {
    ssr: false,
  }),
  noTransport: dynamic(
    () => import('Components/widgets/icons/NoTransport').then(mod('NoTransport')),
    { ssr: false },
  ),
  notebook: dynamic(() => import('Components/widgets/icons/Notebook').then(mod('Notebook')), {
    ssr: false,
  }),
  off: dynamic(() => import('Components/widgets/icons/Off').then(mod('Off')), {
    ssr: false,
  }),
  ofuro: dynamic(() => import('Components/widgets/icons/Ofuro').then(mod('Ofuro')), {
    ssr: false,
  }),
  oil: dynamic(() => import('Components/widgets/icons/Oil').then(mod('Oil')), {
    ssr: false,
  }),
  on: dynamic(() => import('Components/widgets/icons/On').then(mod('On')), {
    ssr: false,
  }),
  onDemand: dynamic(() => import('Components/widgets/icons/OnDemand').then(mod('OnDemand')), {
    ssr: false,
  }),
  opic: dynamic(() => import('Components/widgets/icons/Opic').then(mod('Opic')), {
    ssr: false,
  }),
  calendarOption: dynamic(
    () => import('Components/widgets/icons/CalendarOption').then(mod('CalendarOption')),
    {
      ssr: false,
    },
  ),
  calendarEmpty: dynamic(
    () => import('Components/widgets/icons/CalendarEmpty').then(mod('CalendarEmpty')),
    {
      ssr: false,
    },
  ),
  oven: dynamic(() => import('Components/widgets/icons/Oven').then(mod('Oven')), {
    ssr: false,
  }),
  padelTennis: dynamic(
    () => import('Components/widgets/icons/PadelTennis').then(mod('PadelTennis')),
    { ssr: false },
  ),
  pause: dynamic(() => import('Components/widgets/icons/Pause').then(mod('Pause')), {
    ssr: false,
  }),
  padlock: dynamic(() => import('Components/widgets/icons/Padlock').then(mod('Padlock')), {
    ssr: false,
  }),
  pahc: dynamic(() => import('Components/widgets/icons/Pahc').then(mod('Pahc')), {
    ssr: false,
  }),
  pajamas: dynamic(() => import('Components/widgets/icons/Pajamas').then(mod('Pajamas')), {
    ssr: false,
  }),
  palc: dynamic(() => import('Components/widgets/icons/Palc').then(mod('Palc')), {
    ssr: false,
  }),
  paperDispenser: dynamic(
    () => import('Components/widgets/icons/PaperDispenser').then(mod('PaperDispenser')),
    { ssr: false },
  ),
  parking: dynamic(() => import('Components/widgets/icons/Parking').then(mod('Parking')), {
    ssr: false,
  }),
  passport: dynamic(() => import('Components/widgets/icons/Passport').then(mod('Passport')), {
    ssr: false,
  }),
  passworld: dynamic(() => import('Components/widgets/icons/Passworld').then(mod('Passworld')), {
    ssr: false,
  }),
  cardPaymentPlan: dynamic(
    () => import('Components/widgets/icons/CardPaymentPlan').then(mod('CardPaymentPlan')),
    { ssr: false },
  ),
  pcac: dynamic(() => import('Components/widgets/icons/Pcac').then(mod('Pcac')), {
    ssr: false,
  }),
  pdf: dynamic(() => import('Components/widgets/icons/Pdf').then(mod('Pdf')), {
    ssr: false,
  }),
  pen: dynamic(() => import('Components/widgets/icons/Pen').then(mod('Pen')), {
    ssr: false,
  }),
  people: dynamic(() => import('Components/widgets/icons/People').then(mod('People')), {
    ssr: false,
  }),
  peopleDouble: dynamic(
    () => import('Components/widgets/icons/PeopleDouble').then(mod('PeopleDouble')),
    {
      ssr: false,
    },
  ),
  peopleTriple: dynamic(
    () => import('Components/widgets/icons/PeopleTriple').then(mod('PeopleTriple')),
    {
      ssr: false,
    },
  ),
  percentage: dynamic(() => import('Components/widgets/icons/Percentage').then(mod('Percentage')), {
    ssr: false,
  }),
  petanque: dynamic(() => import('Components/widgets/icons/Petanque').then(mod('Petanque')), {
    ssr: false,
  }),
  petitClub: dynamic(() => import('Components/widgets/icons/PetitClub').then(mod('PetitClub')), {
    ssr: false,
  }),
  phone: dynamic(() => import('Components/widgets/icons/Phone').then(mod('Phone')), {
    ssr: true,
  }),
  phoneBubble: dynamic(
    () => import('Components/widgets/icons/PhoneBubble').then(mod('PhoneBubble')),
    { ssr: false },
  ),
  phoneLight: dynamic(() => import('Components/widgets/icons/PhoneLight').then(mod('PhoneLight')), {
    ssr: false,
  }),
  pickleball: dynamic(() => import('Components/widgets/icons/Pickleball').then(mod('Pickleball')), {
    ssr: false,
  }),
  mediaPicture: dynamic(
    () => import('Components/widgets/icons/MediaPicture').then(mod('MediaPicture')),
    { ssr: false },
  ),
  phuc: dynamic(() => import('Components/widgets/icons/Phuc').then(mod('Phuc')), {
    ssr: false,
  }),
  pin_amenity: dynamic(
    () => import('Components/widgets/icons/PinAmenity').then(mod('PinAmenity')),
    { ssr: false },
  ),
  pin_room: dynamic(() => import('Components/widgets/icons/PinRoom').then(mod('PinRoom')), {
    ssr: false,
  }),
  pin_room_highlight: dynamic(
    () => import('Components/widgets/icons/PinRoomHighlight').then(mod('PinRoomHighlight')),
    { ssr: false },
  ),
  plac: dynamic(() => import('Components/widgets/icons/Plac').then(mod('Plac')), {
    ssr: false,
  }),
  plane: dynamic(() => import('Components/widgets/icons/Plane').then(mod('Plane')), {
    ssr: false,
  }),
  planeAndCircle: dynamic(
    () => import('Components/widgets/icons/PlaneAndCircle').then(mod('PlaneAndCircle')),
    { ssr: false },
  ),
  planeComfort: dynamic(
    () => import('Components/widgets/icons/PlaneComfort').then(mod('PlaneComfort')),
    { ssr: false },
  ),
  plates: dynamic(() => import('Components/widgets/icons/Plates').then(mod('Plates')), {
    ssr: false,
  }),
  plus: dynamic(() => import('Components/widgets/icons/Plus').then(mod('Plus')), {
    ssr: false,
  }),
  plusFilled: dynamic(() => import('Components/widgets/icons/PlusFilled').then(mod('PlusFilled')), {
    ssr: false,
  }),
  plusOutline: dynamic(
    () => import('Components/widgets/icons/PlusOutline').then(mod('PlusOutline')),
    {
      ssr: false,
    },
  ),
  pmr: dynamic(() => import('Components/widgets/icons/Pmr').then(mod('Pmr')), {
    ssr: false,
  }),
  'pool-towels': dynamic(
    () => import('Components/widgets/icons/PoolTowels').then(mod('PoolTowels')),
    { ssr: false },
  ),
  'pool-view': dynamic(() => import('Components/widgets/icons/PoolView').then(mod('PoolView')), {
    ssr: false,
  }),
  poolside: dynamic(() => import('Components/widgets/icons/Poolside').then(mod('Poolside')), {
    ssr: false,
  }),
  potty: dynamic(() => import('Components/widgets/icons/Potty').then(mod('Potty')), {
    ssr: false,
  }),
  prac: dynamic(() => import('Components/widgets/icons/Prac').then(mod('Prac')), {
    ssr: false,
  }),
  pressing: dynamic(() => import('Components/widgets/icons/Pressing').then(mod('Pressing')), {
    ssr: false,
  }),
  priceTag: dynamic(() => import('Components/widgets/icons/PriceTag').then(mod('PriceTag')), {
    ssr: false,
  }),
  priorityspa: dynamic(
    () => import('Components/widgets/icons/Priorityspa').then(mod('Priorityspa')),
    { ssr: false },
  ),
  privateMeal: dynamic(
    () => import('Components/widgets/icons/PrivateMeal').then(mod('PrivateMeal')),
    { ssr: false },
  ),
  'private-bathroom': dynamic(
    () => import('Components/widgets/icons/PrivateBathroom').then(mod('PrivateBathroom')),
    { ssr: false },
  ),
  'private-furnished-terrace': dynamic(
    () =>
      import('Components/widgets/icons/PrivateFurnishedTerrace').then(
        mod('PrivateFurnishedTerrace'),
      ),
    { ssr: false },
  ),
  'private-garden': dynamic(
    () => import('Components/widgets/icons/PrivateGarden').then(mod('PrivateGarden')),
    { ssr: false },
  ),
  'private-pool': dynamic(
    () => import('Components/widgets/icons/PrivatePool').then(mod('PrivatePool')),
    { ssr: false },
  ),
  'private-ski': dynamic(
    () => import('Components/widgets/icons/PrivateSki').then(mod('PrivateSki')),
    { ssr: false },
  ),
  privateTransfer: dynamic(
    () => import('Components/widgets/icons/PrivateTransfer').then(mod('PrivateTransfer')),
    { ssr: false },
  ),
  promoCode: dynamic(() => import('Components/widgets/icons/PromoCode').then(mod('PromoCode')), {
    ssr: false,
  }),
  pvac: dynamic(() => import('Components/widgets/icons/Pvac').then(mod('Pvac')), {
    ssr: false,
  }),
  qchc: dynamic(() => import('Components/widgets/icons/Qchc').then(mod('Qchc')), {
    ssr: false,
  }),
  quiche: dynamic(() => import('Components/widgets/icons/Quiche').then(mod('Quiche')), {
    ssr: false,
  }),
  quotationMark: dynamic(
    () => import('Components/widgets/icons/QuotationMark').then(mod('QuotationMark')),
    { ssr: false },
  ),
  raclette: dynamic(() => import('Components/widgets/icons/Raclette').then(mod('Raclette')), {
    ssr: false,
  }),
  rainshower: dynamic(() => import('Components/widgets/icons/Rainshower').then(mod('Rainshower')), {
    ssr: false,
  }),
  rbic: dynamic(() => import('Components/widgets/icons/Rbic').then(mod('Rbic')), {
    ssr: false,
  }),
  rdpc: dynamic(() => import('Components/widgets/icons/Rdpc').then(mod('Rdpc')), {
    ssr: false,
  }),
  receipt: dynamic(() => import('Components/widgets/icons/Receipt').then(mod('Receipt')), {
    ssr: false,
  }),
  reception: dynamic(() => import('Components/widgets/icons/Reception').then(mod('Reception')), {
    ssr: false,
  }),
  receptionMask: dynamic(
    () => import('Components/widgets/icons/ReceptionMask').then(mod('ReceptionMask')),
    { ssr: false },
  ),
  'repartition-baby': dynamic(
    () => import('Components/widgets/icons/RepartitionBaby').then(mod('RepartitionBaby')),
    { ssr: false },
  ),
  reload: dynamic(() => import('Components/widgets/icons/Reload').then(mod('Reload')), {
    ssr: false,
  }),
  restaurant: dynamic(() => import('Components/widgets/icons/Restaurant').then(mod('Restaurant')), {
    ssr: false,
  }),
  restaurantMask: dynamic(
    () => import('Components/widgets/icons/RestaurantMask').then(mod('RestaurantMask')),
    { ssr: false },
  ),
  clockBack: dynamic(() => import('Components/widgets/icons/ClockBack').then(mod('ClockBack')), {
    ssr: false,
  }),
  clock: dynamic(() => import('Components/widgets/icons/Clock').then(mod('Clock')), {
    ssr: false,
  }),
  riding: dynamic(() => import('Components/widgets/icons/Riding').then(mod('Riding')), {
    ssr: false,
  }),
  'river-view': dynamic(() => import('Components/widgets/icons/RiverView').then(mod('RiverView')), {
    ssr: false,
  }),
  roller: dynamic(() => import('Components/widgets/icons/Roller').then(mod('Roller')), {
    ssr: false,
  }),
  'room-service': dynamic(
    () => import('Components/widgets/icons/RoomService').then(mod('RoomService')),
    { ssr: false },
  ),
  room: dynamic(() => import('Components/widgets/icons/Room').then(mod('Room')), {
    ssr: false,
  }),
  rooms: dynamic(() => import('Components/widgets/icons/Rooms').then(mod('Rooms')), {
    ssr: false,
  }),
  running: dynamic(() => import('Components/widgets/icons/Running').then(mod('Running')), {
    ssr: false,
  }),
  safe: dynamic(() => import('Components/widgets/icons/Safe').then(mod('Safe')), {
    ssr: false,
  }),
  saferoom: dynamic(() => import('Components/widgets/icons/Saferoom').then(mod('Saferoom')), {
    ssr: false,
  }),
  sailing: dynamic(() => import('Components/widgets/icons/Sailing').then(mod('Sailing')), {
    ssr: false,
  }),
  salad: dynamic(() => import('Components/widgets/icons/Salad').then(mod('Salad')), {
    ssr: false,
  }),
  samc: dynamic(() => import('Components/widgets/icons/Samc').then(mod('Samc')), {
    ssr: false,
  }),
  sanc: dynamic(() => import('Components/widgets/icons/Sanc').then(mod('Sanc')), {
    ssr: false,
  }),
  promotionLastMinute: dynamic(
    () => import('Components/widgets/icons/PromotionLastMinute').then(mod('PromotionLastMinute')),
    { ssr: false },
  ),
  percentageMakeup: dynamic(
    () => import('Components/widgets/icons/PercentageMakeup').then(mod('PercentageMakeup')),
    { ssr: false },
  ),
  promotion: dynamic(() => import('Components/widgets/icons/Promotion').then(mod('Promotion')), {
    ssr: false,
  }),
  saoc: dynamic(() => import('Components/widgets/icons/Saoc').then(mod('Saoc')), {
    ssr: false,
  }),
  sayc: dynamic(() => import('Components/widgets/icons/Sayc').then(mod('Sayc')), {
    ssr: false,
  }),
  schc: dynamic(() => import('Components/widgets/icons/Schc').then(mod('Schc')), {
    ssr: false,
  }),
  sea_side: dynamic(() => import('Components/widgets/icons/SeaSide').then(mod('SeaSide')), {
    ssr: false,
  }),
  sea_view: dynamic(() => import('Components/widgets/icons/SeaSide').then(mod('SeaSide')), {
    ssr: false,
  }),
  searchGlass: dynamic(
    () => import('Components/widgets/icons/SearchGlass').then(mod('SearchGlass')),
    { ssr: true },
  ),
  seaview: dynamic(() => import('Components/widgets/icons/Seaview').then(mod('Seaview')), {
    ssr: false,
  }),
  secureKey: dynamic(() => import('Components/widgets/icons/SecureKey').then(mod('SecureKey')), {
    ssr: false,
  }),
  separate: dynamic(() => import('Components/widgets/icons/Separate').then(mod('Separate')), {
    ssr: false,
  }),
  separate3: dynamic(() => import('Components/widgets/icons/Separate3').then(mod('Separate3')), {
    ssr: false,
  }),
  separated_buildings: dynamic(
    () => import('Components/widgets/icons/SeparatedBuildings').then(mod('SeparatedBuildings')),
    { ssr: false },
  ),
  shared_room: dynamic(
    () => import('Components/widgets/icons/SharedRoom').then(mod('SharedRoom')),
    { ssr: false },
  ),
  separatedtoilets: dynamic(
    () => import('Components/widgets/icons/Separatedtoilets').then(mod('Separatedtoilets')),
    { ssr: false },
  ),
  filters: dynamic(() => import('Components/widgets/icons/Filters').then(mod('Filters')), {
    ssr: false,
  }),
  seyc: dynamic(() => import('Components/widgets/icons/Seyc').then(mod('Seyc')), {
    ssr: false,
  }),
  shampoo: dynamic(() => import('Components/widgets/icons/Shampoo').then(mod('Shampoo')), {
    ssr: false,
  }),
  share: dynamic(() => import('Components/widgets/icons/Share').then(mod('Share')), {
    ssr: false,
  }),
  sheets: dynamic(() => import('Components/widgets/icons/Sheets').then(mod('Sheets')), {
    ssr: false,
  }),
  shower: dynamic(() => import('Components/widgets/icons/Shower').then(mod('Shower')), {
    ssr: false,
  }),
  showerbathtub: dynamic(
    () => import('Components/widgets/icons/Showerbathtub').then(mod('Showerbathtub')),
    { ssr: false },
  ),
  showerdualwashbasin: dynamic(
    () => import('Components/widgets/icons/Showerdualwashbasin').then(mod('Showerdualwashbasin')),
    { ssr: false },
  ),
  showertoilets: dynamic(
    () => import('Components/widgets/icons/Showertoilets').then(mod('Showertoilets')),
    { ssr: false },
  ),
  showerwashbasin: dynamic(
    () => import('Components/widgets/icons/Showerwashbasin').then(mod('Showerwashbasin')),
    { ssr: false },
  ),
  shuttleBus: dynamic(() => import('Components/widgets/icons/ShuttleBus').then(mod('ShuttleBus')), {
    ssr: false,
  }),
  sibc: dynamic(() => import('Components/widgets/icons/Sibc').then(mod('Sibc')), {
    ssr: false,
  }),
  signout: dynamic(() => import('Components/widgets/icons/Signout').then(mod('Signout')), {
    ssr: false,
  }),
  single: dynamic(() => import('Components/widgets/icons/Single').then(mod('Single')), {
    ssr: false,
  }),
  sink: dynamic(() => import('Components/widgets/icons/Sink').then(mod('Sink')), {
    ssr: false,
  }),
  size: dynamic(() => import('Components/widgets/icons/Size').then(mod('Size')), {
    ssr: false,
  }),
  'ski-resort': dynamic(() => import('Components/widgets/icons/SkiResort').then(mod('SkiResort')), {
    ssr: false,
  }),
  ski: dynamic(() => import('Components/widgets/icons/Ski').then(mod('Ski')), {
    ssr: false,
  }),
  skiAndPoles: dynamic(
    () => import('Components/widgets/icons/SkiAndPoles').then(mod('SkiAndPoles')),
    { ssr: false },
  ),
  skiEquipments: dynamic(
    () => import('Components/widgets/icons/SkiEquipments').then(mod('SkiEquipments')),
    { ssr: false },
  ),
  ski_in_out: dynamic(() => import('Components/widgets/icons/SkiInOut').then(mod('SkiInOut')), {
    ssr: false,
  }),
  skilocker: dynamic(() => import('Components/widgets/icons/Skilocker').then(mod('Skilocker')), {
    ssr: false,
  }),
  skimMilk: dynamic(() => import('Components/widgets/icons/SkimMilk').then(mod('SkimMilk')), {
    ssr: false,
  }),
  skinjay: dynamic(() => import('Components/widgets/icons/Skinjay').then(mod('Skinjay')), {
    ssr: false,
  }),
  skiRoom: dynamic(() => import('Components/widgets/icons/SkiRoom').then(mod('SkiRoom')), {
    ssr: false,
  }),
  slippers: dynamic(() => import('Components/widgets/icons/Slippers').then(mod('Slippers')), {
    ssr: false,
  }),
  'slopes-view': dynamic(
    () => import('Components/widgets/icons/SlopesView').then(mod('SlopesView')),
    { ssr: false },
  ),
  soup: dynamic(() => import('Components/widgets/icons/Soup').then(mod('Soup')), {
    ssr: false,
  }),
  checkOutline: dynamic(
    () => import('Components/widgets/icons/CheckOutline').then(mod('CheckOutline')),
    { ssr: false },
  ),
  smrc: dynamic(() => import('Components/widgets/icons/Smrc').then(mod('Smrc')), {
    ssr: false,
  }),
  snacks: dynamic(() => import('Components/widgets/icons/Snacks').then(mod('Snacks')), {
    ssr: false,
  }),
  snorkelling: dynamic(
    () => import('Components/widgets/icons/Snorkelling').then(mod('Snorkelling')),
    { ssr: false },
  ),
  snowboard: dynamic(() => import('Components/widgets/icons/Snowboard').then(mod('Snowboard')), {
    ssr: false,
  }),
  snowboardSkin: dynamic(
    () => import('Components/widgets/icons/SnowboardSkin').then(mod('SnowboardSkin')),
    { ssr: false },
  ),
  soap: dynamic(() => import('Components/widgets/icons/Soap').then(mod('Soap')), {
    ssr: false,
  }),
  soapDispenser: dynamic(
    () => import('Components/widgets/icons/SoapDispenser').then(mod('SoapDispenser')),
    { ssr: false },
  ),
  solution: dynamic(() => import('Components/widgets/icons/Solution').then(mod('Solution')), {
    ssr: false,
  }),
  spa: dynamic(() => import('Components/widgets/icons/Spa').then(mod('Spa')), {
    ssr: false,
  }),
  spaMask: dynamic(() => import('Components/widgets/icons/SpaMask').then(mod('SpaMask')), {
    ssr: false,
  }),
  specialOffers: dynamic(
    () => import('Components/widgets/icons/SpecialOffers').then(mod('SpecialOffers')),
    { ssr: false },
  ),
  spoon: dynamic(() => import('Components/widgets/icons/Spoon').then(mod('Spoon')), {
    ssr: false,
  }),
  sport: dynamic(() => import('Components/widgets/icons/Sport').then(mod('Sport')), {
    ssr: false,
  }),
  sport_school: dynamic(
    () => import('Components/widgets/icons/SportSchool').then(mod('SportSchool')),
    { ssr: false },
  ),
  stand_up_paddle: dynamic(
    () => import('Components/widgets/icons/StandUpPaddle').then(mod('StandUpPaddle')),
    { ssr: false },
  ),
  StandaloneMagnifyingGlass: dynamic(
    () =>
      import('Components/widgets/icons/StandaloneMagnifyingGlass').then(
        mod('StandaloneMagnifyingGlass'),
      ),
    { ssr: false },
  ),
  starFilled: dynamic(() => import('Components/widgets/icons/StarFilled').then(mod('StarFilled')), {
    ssr: false,
  }),
  starHollow: dynamic(() => import('Components/widgets/icons/StarHollow').then(mod('StarHollow')), {
    ssr: false,
  }),
  starlist: dynamic(() => import('Components/widgets/icons/Starlist').then(mod('Starlist')), {
    ssr: false,
  }),
  stereo: dynamic(() => import('Components/widgets/icons/Stereo').then(mod('Stereo')), {
    ssr: false,
  }),
  sterilizer: dynamic(() => import('Components/widgets/icons/Sterilizer').then(mod('Sterilizer')), {
    ssr: false,
  }),
  stEasyArrival: dynamic(
    () => import('Components/widgets/icons/SafeTogetherEasyArrival').then(mod('EasyArrival')),
    { ssr: false },
  ),
  stInsurance: dynamic(
    () => import('Components/widgets/icons/SafeTogetherInsurance').then(mod('Insurance')),
    { ssr: false },
  ),
  stopMarker: dynamic(() => import('Components/widgets/icons/StopMarker').then(mod('StopMarker')), {
    ssr: false,
  }),
  storeLocator: dynamic(
    () => import('Components/widgets/icons/StoreLocator').then(mod('StoreLocator')),
    { ssr: false },
  ),
  streetViews360: dynamic(
    () => import('Components/widgets/icons/StreetViews360').then(mod('StreetViews360')),
    { ssr: false },
  ),
  stroller: dynamic(() => import('Components/widgets/icons/Stroller').then(mod('Stroller')), {
    ssr: false,
  }),
  stSoap: dynamic(() => import('Components/widgets/icons/safeTogetherSoap').then(mod('Soap')), {
    ssr: false,
  }),
  suite: dynamic(() => import('Components/widgets/icons/Suite').then(mod('Suite')), {
    ssr: false,
  }),
  summary: dynamic(() => import('Components/widgets/icons/Summary').then(mod('Summary')), {
    ssr: false,
  }),
  surf: dynamic(() => import('Components/widgets/icons/Surf').then(mod('Surf')), {
    ssr: false,
  }),
  swim: dynamic(() => import('Components/widgets/icons/Swim').then(mod('Swim')), {
    ssr: false,
  }),
  swimmingpool: dynamic(
    () => import('Components/widgets/icons/Swimmingpool').then(mod('Swimmingpool')),
    { ssr: false },
  ),
  'table-tennis': dynamic(
    () => import('Components/widgets/icons/TableTennis').then(mod('TableTennis')),
    { ssr: false },
  ),
  table: dynamic(() => import('Components/widgets/icons/Table').then(mod('Table')), {
    ssr: false,
  }),
  tacj: dynamic(() => import('Components/widgets/icons/Tacj').then(mod('Tacj')), {
    ssr: false,
  }),
  takeAway: dynamic(() => import('Components/widgets/icons/TakeAway').then(mod('TakeAway')), {
    ssr: false,
  }),
  takeOff: dynamic(() => import('Components/widgets/icons/TakeOff').then(mod('TakeOff')), {
    ssr: false,
  }),
  tapas: dynamic(() => import('Components/widgets/icons/Tapas').then(mod('Tapas')), {
    ssr: false,
  }),
  television: dynamic(() => import('Components/widgets/icons/Television').then(mod('Television')), {
    ssr: false,
  }),
  temperature: dynamic(
    () => import('Components/widgets/icons/Temperature').then(mod('Temperature')),
    { ssr: false },
  ),
  tennis: dynamic(() => import('Components/widgets/icons/Tennis').then(mod('Tennis')), {
    ssr: false,
  }),
  terrace: dynamic(() => import('Components/widgets/icons/Terrace').then(mod('Terrace')), {
    ssr: false,
  }),
  thac: dynamic(() => import('Components/widgets/icons/Thac').then(mod('Thac')), {
    ssr: false,
  }),
  oney_3x: dynamic(
    () => import('Components/widgets/icons/ThreeTimesOney').then(mod('ThreeXOney')),
    {
      ssr: false,
    },
  ),
  tigc: dynamic(() => import('Components/widgets/icons/Tigc').then(mod('Tigc')), {
    ssr: false,
  }),
  tomc: dynamic(() => import('Components/widgets/icons/Tomc').then(mod('Tomc')), {
    ssr: false,
  }),
  toweldryer: dynamic(() => import('Components/widgets/icons/Toweldryer').then(mod('Toweldryer')), {
    ssr: false,
  }),
  trac: dynamic(() => import('Components/widgets/icons/Trac').then(mod('Trac')), {
    ssr: false,
  }),
  'train-transport': dynamic(
    () => import('Components/widgets/icons/TrainTransport').then(mod('TrainTransport')),
    { ssr: false },
  ),
  transfer: dynamic(() => import('Components/widgets/icons/Transfer').then(mod('Transfer')), {
    ssr: false,
  }),
  transport: dynamic(() => import('Components/widgets/icons/Transport').then(mod('Transport')), {
    ssr: false,
  }),
  transport_service_in_resort: dynamic(
    () =>
      import('Components/widgets/icons/TransportServiceInResort').then(
        mod('TransportServiceInResort'),
      ),
    { ssr: false },
  ),
  trapeze: dynamic(() => import('Components/widgets/icons/Trapeze').then(mod('Trapeze')), {
    ssr: false,
  }),
  trashCan: dynamic(() => import('Components/widgets/icons/TrashCan').then(mod('TrashCan')), {
    ssr: false,
  }),
  travelSafe: dynamic(() => import('Components/widgets/icons/TravelSafe').then(mod('TravelSafe')), {
    ssr: false,
  }),
  treetop_adventure: dynamic(
    () => import('Components/widgets/icons/TreetopAdventure').then(mod('TreetopAdventure')),
    { ssr: false },
  ),
  trident: dynamic(() => import('Components/widgets/icons/Trident1').then(mod('Trident1')), {
    ssr: false,
  }),
  trident1: dynamic(() => import('Components/widgets/icons/Trident1').then(mod('Trident1')), {
    ssr: false,
  }),
  trident2: dynamic(() => import('Components/widgets/icons/Trident2').then(mod('Trident2')), {
    ssr: false,
  }),
  trident3: dynamic(() => import('Components/widgets/icons/Trident3').then(mod('Trident3')), {
    ssr: false,
  }),
  trident4: dynamic(() => import('Components/widgets/icons/Trident4').then(mod('Trident4')), {
    ssr: false,
  }),
  trident5: dynamic(() => import('Components/widgets/icons/Trident5').then(mod('Trident5')), {
    ssr: false,
  }),
  trident6: dynamic(() => import('Components/widgets/icons/Trident6').then(mod('Trident6')), {
    ssr: false,
  }),
  tridentjoyview: dynamic(
    () => import('Components/widgets/icons/Tridentjoyview').then(mod('Tridentjoyview')),
    { ssr: false },
  ),
  union: dynamic(() => import('Components/widgets/icons/Union').then(mod('Union')), {
    ssr: false,
  }),
  turc: dynamic(() => import('Components/widgets/icons/Turc').then(mod('Turc')), {
    ssr: false,
  }),
  tvcc: dynamic(() => import('Components/widgets/icons/Tvcc').then(mod('Tvcc')), {
    ssr: false,
  }),
  umbrella: dynamic(() => import('Components/widgets/icons/Umbrella').then(mod('Umbrella')), {
    ssr: false,
  }),
  clockSpeed: dynamic(() => import('Components/widgets/icons/ClockSpeed').then(mod('ClockSpeed')), {
    ssr: false,
  }),
  usb: dynamic(() => import('Components/widgets/icons/Usb').then(mod('Usb')), {
    ssr: false,
  }),
  userDetails: dynamic(
    () => import('Components/widgets/icons/UserDetails').then(mod('UserDetails')),
    {
      ssr: false,
    },
  ),
  'valley-view': dynamic(
    () => import('Components/widgets/icons/ValleyView').then(mod('ValleyView')),
    { ssr: false },
  ),
  vdic: dynamic(() => import('Components/widgets/icons/Vdic').then(mod('Vdic')), {
    ssr: false,
  }),
  ventilatedlocker: dynamic(
    () => import('Components/widgets/icons/Ventilatedlocker').then(mod('Ventilatedlocker')),
    { ssr: false },
  ),
  vegan: dynamic(() => import('Components/widgets/icons/Vegan').then(mod('Vegan')), {
    ssr: false,
  }),
  vegetarian: dynamic(() => import('Components/widgets/icons/Vegetarian').then(mod('Vegetarian')), {
    ssr: false,
  }),
  vegetables: dynamic(() => import('Components/widgets/icons/Vegetables').then(mod('Vegetables')), {
    ssr: false,
  }),
  verc: dynamic(() => import('Components/widgets/icons/Verc').then(mod('Verc')), {
    ssr: false,
  }),
  mediaVideo: dynamic(() => import('Components/widgets/icons/MediaVideo').then(mod('MediaVideo')), {
    ssr: false,
  }),
  videos360: dynamic(
    () => import('Components/widgets/icons/Media360Video').then(mod('Media360Video')),
    { ssr: false },
  ),
  visc: dynamic(() => import('Components/widgets/icons/Visc').then(mod('Visc')), {
    ssr: false,
  }),
  vlpc: dynamic(() => import('Components/widgets/icons/Vlpc').then(mod('Vlpc')), {
    ssr: false,
  }),
  vmoc: dynamic(() => import('Components/widgets/icons/Vmoc').then(mod('Vmoc')), {
    ssr: false,
  }),
  vmov: dynamic(() => import('Components/widgets/icons/Vmov').then(mod('Vmov')), {
    ssr: false,
  }),
  volleyball: dynamic(() => import('Components/widgets/icons/Volleyball').then(mod('Volleyball')), {
    ssr: false,
  }),
  voiceMail: dynamic(() => import('Components/widgets/icons/VoiceMail').then(mod('VoiceMail')), {
    ssr: false,
  }),
  vsoc: dynamic(() => import('Components/widgets/icons/Vsoc').then(mod('Vsoc')), {
    ssr: false,
  }),
  vthc: dynamic(() => import('Components/widgets/icons/Vthc').then(mod('Vthc')), {
    ssr: false,
  }),
  vtt: dynamic(() => import('Components/widgets/icons/Vtt').then(mod('Vtt')), {
    ssr: false,
  }),
  walking: dynamic(() => import('Components/widgets/icons/Walking').then(mod('Walking')), {
    ssr: false,
  }),
  warning: dynamic(() => import('Components/widgets/icons/Warning').then(mod('Warning')), {
    ssr: false,
  }),
  washingmachine: dynamic(
    () => import('Components/widgets/icons/Washingmachine').then(mod('Washingmachine')),
    { ssr: false },
  ),
  wash: dynamic(() => import('Components/widgets/icons/Wash').then(mod('Wash')), {
    ssr: false,
  }),
  waterFountain: dynamic(
    () => import('Components/widgets/icons/WaterFountain').then(mod('WaterFountain')),
    { ssr: false },
  ),
  waterbottle: dynamic(
    () => import('Components/widgets/icons/Waterbottle').then(mod('Waterbottle')),
    { ssr: false },
  ),
  waterski: dynamic(() => import('Components/widgets/icons/Waterski').then(mod('Waterski')), {
    ssr: false,
  }),
  weight: dynamic(() => import('Components/widgets/icons/Weight').then(mod('Weight')), {
    ssr: false,
  }),
  welcomegift: dynamic(
    () => import('Components/widgets/icons/Welcomegift').then(mod('Welcomegift')),
    { ssr: false },
  ),
  'well-being': dynamic(() => import('Components/widgets/icons/WellBeing').then(mod('WellBeing')), {
    ssr: false,
  }),
  wellBeingAtWork: dynamic(
    () => import('Components/widgets/icons/WellBeingAtWork').then(mod('WellBeingAtWork')),
    { ssr: false },
  ),
  wholeMilk: dynamic(() => import('Components/widgets/icons/WholeMilk').then(mod('WholeMilk')), {
    ssr: false,
  }),
  wifi: dynamic(() => import('Components/widgets/icons/Wifi').then(mod('Wifi')), {
    ssr: false,
  }),
  windsurfing: dynamic(
    () => import('Components/widgets/icons/Windsurfing').then(mod('Windsurfing')),
    { ssr: false },
  ),
  wingfoil: dynamic(() => import('Components/widgets/icons/WingFoil').then(mod('WingFoil')), {
    ssr: false,
  }),
  wine: dynamic(() => import('Components/widgets/icons/Wine').then(mod('Wine')), {
    ssr: false,
  }),
  wineCellar: dynamic(() => import('Components/widgets/icons/WineCellar').then(mod('WineCellar')), {
    ssr: false,
  }),
  xlij: dynamic(() => import('Components/widgets/icons/Xlij').then(mod('Xlij')), {
    ssr: false,
  }),
  yabc: dynamic(() => import('Components/widgets/icons/Yabc').then(mod('Yabc')), {
    ssr: false,
  }),
  yanj: dynamic(() => import('Components/widgets/icons/Yanj').then(mod('Yanj')), {
    ssr: false,
  }),
  yaqj: dynamic(() => import('Components/widgets/icons/Yanj').then(mod('Yanj')), {
    ssr: false,
  }),
  yasc: dynamic(() => import('Components/widgets/icons/Yasc').then(mod('Yasc')), {
    ssr: false,
  }),
  yoga: dynamic(() => import('Components/widgets/icons/Yoga').then(mod('Yoga')), {
    ssr: false,
  }),
  yogamat: dynamic(() => import('Components/widgets/icons/Yogamat').then(mod('Yogamat')), {
    ssr: false,
  }),
  zenzone: dynamic(() => import('Components/widgets/icons/Zenzone').then(mod('Zenzone')), {
    ssr: false,
  }),
  '1Stop': dynamic(() => import('Components/widgets/icons/Svg1Stop').then(mod('Svg1Stop')), {
    ssr: false,
  }),
  '2Stops': dynamic(() => import('Components/widgets/icons/Svg2Stops').then(mod('Svg2Stops')), {
    ssr: false,
  }),
  404: dynamic(() => import('Components/widgets/icons/Svg404').then(mod('Svg404')), {
    ssr: false,
  }),
  winterMountainResorts: dynamic(
    () =>
      import('Components/widgets/icons/WinterMountainResorts').then(mod('WinterMountainResorts')),
    { ssr: false },
  ),
  wechat: dynamic(() => import('Components/widgets/icons/Wechat').then(mod('Wechat')), {
    ssr: false,
  }),
  whatsapp: dynamic(() => import('Components/widgets/icons/Whatsapp').then(mod('Whatsapp')), {
    ssr: false,
  }),
  ClubMedExclusive: dynamic(
    () => import('Components/widgets/icons/ClubMedExclusive').then(mod('ClubMedExclusive')),
    { ssr: false },
  ),
  allInclusiveWithShadow: dynamic(
    () =>
      import('Components/widgets/icons/AllInclusiveWithShadow').then(mod('AllInclusiveWithShadow')),
    { ssr: false },
  ),
  callMeBack: dynamic(() => import('Components/widgets/icons/CallMeBack').then(mod('CallMeBack')), {
    ssr: false,
  }),
  cough: dynamic(() => import('Components/widgets/icons/Cough').then(mod('Cough')), {
    ssr: false,
  }),
  charmPrestige: dynamic(
    () => import('Components/widgets/icons/CharmPrestige').then(mod('CharmPrestige')),
    { ssr: false },
  ),
  checkFilled: dynamic(
    () => import('Components/widgets/icons/CheckFilled').then(mod('CheckFilled')),
    { ssr: false },
  ),
  clubmedAllInclusiveLargeChina: dynamic(
    () =>
      import('Components/widgets/icons/ClubmedAllInclusiveLargeChina').then(
        mod('ClubmedAllInclusiveLargeChina'),
      ),
    { ssr: false },
  ),
  clubmedAllInclusiveSmallChina: dynamic(
    () =>
      import('Components/widgets/icons/ClubmedAllInclusiveSmallChina').then(
        mod('ClubmedAllInclusiveSmallChina'),
      ),
    { ssr: false },
  ),
  clubmedcollectivites: dynamic(
    () => import('Components/widgets/icons/ClubmedCollectivites').then(mod('ClubmedCollectivites')),
    { ssr: false },
  ),
  clubmedGreatMember: dynamic(
    () => import('Components/widgets/icons/ClubMedGreatMember').then(mod('ClubMedGreatMember')),
    { ssr: false },
  ),
  clubmedGreatMemberNew: dynamic(
    () =>
      import('Components/widgets/icons/ClubMedGreatMemberNew').then(mod('ClubMedGreatMemberNew')),
    { ssr: false },
  ),
  clubmedLogoGreatMembersTrade: dynamic(
    () =>
      import('Components/widgets/icons/ClubmedLogoGreatMembersTrade').then(
        mod('ClubmedLogoGreatMembersTrade'),
      ),
    { ssr: false },
  ),
  dmd_standard: dynamic(
    () => import('Components/widgets/icons/DmdStandard').then(mod('DmdStandard')),
    { ssr: false },
  ),
  dollar: dynamic(() => import('Components/widgets/icons/Dollar').then(mod('Dollar')), {
    ssr: false,
  }),
  douban: dynamic(() => import('Components/widgets/icons/Douban').then(mod('Douban')), {
    ssr: false,
  }),
  earlySun: dynamic(() => import('Components/widgets/icons/EarlySun').then(mod('EarlySun')), {
    ssr: false,
  }),
  faq: dynamic(() => import('Components/widgets/icons/Faq').then(mod('Faq')), {
    ssr: false,
  }),
  flexibleWithShadow: dynamic(
    () => import('Components/widgets/icons/FlexibleWithShadow').then(mod('FlexibleWithShadow')),
    { ssr: false },
  ),
  flickr: dynamic(() => import('Components/widgets/icons/Flickr').then(mod('Flickr')), {
    ssr: false,
  }),
  garden: dynamic(() => import('Components/widgets/icons/Garden').then(mod('Garden')), {
    ssr: false,
  }),
  gentilbot: dynamic(() => import('Components/widgets/icons/GentilBot').then(mod('GentilBot')), {
    ssr: false,
  }),
  GreatMembersGold: dynamic(
    () => import('Components/widgets/icons/GreatMembersGold').then(mod('GreatMembersGold')),
    { ssr: false },
  ),
  GreatMembersPlatinum: dynamic(
    () => import('Components/widgets/icons/GreatMembersPlatinum').then(mod('GreatMembersPlatinum')),
    { ssr: false },
  ),
  GreatMembersSilver: dynamic(
    () => import('Components/widgets/icons/GreatMembersSilver').then(mod('GreatMembersSilver')),
    { ssr: false },
  ),
  GreatMembersTurquoise: dynamic(
    () =>
      import('Components/widgets/icons/GreatMembersTurquoise').then(mod('GreatMembersTurquoise')),
    { ssr: false },
  ),
  GreatMembersGoldTrident: dynamic(
    () =>
      import('Components/widgets/icons/GreatMembersGoldTrident').then(
        mod('GreatMembersGoldTrident'),
      ),
    { ssr: false },
  ),
  GreatMembersPlatinumTrident: dynamic(
    () =>
      import('Components/widgets/icons/GreatMembersPlatinumTrident').then(
        mod('GreatMembersPlatinumTrident'),
      ),
    { ssr: false },
  ),
  GreatMembersSilverTrident: dynamic(
    () =>
      import('Components/widgets/icons/GreatMembersSilverTrident').then(
        mod('GreatMembersSilverTrident'),
      ),
    { ssr: false },
  ),
  GreatMembersTurquoiseTrident: dynamic(
    () =>
      import('Components/widgets/icons/GreatMembersTurquoiseTrident').then(
        mod('GreatMembersTurquoiseTrident'),
      ),
    { ssr: false },
  ),
  GreatMembersWithShadow: dynamic(
    () =>
      import('Components/widgets/icons/GreatMembersWithShadow').then(mod('GreatMembersWithShadow')),
    { ssr: false },
  ),
  introTrident: dynamic(
    () => import('Components/widgets/icons/IntroTrident').then(mod('IntroTrident')),
    { ssr: false },
  ),
  kids: dynamic(() => import('Components/widgets/icons/Kids').then(mod('Kids')), {
    ssr: false,
  }),
  lateSun: dynamic(() => import('Components/widgets/icons/LateSun').then(mod('LateSun')), {
    ssr: false,
  }),
  link: dynamic(() => import('Components/widgets/icons/Link').then(mod('Link')), {
    ssr: false,
  }),
  luggagetransport: dynamic(
    () => import('Components/widgets/icons/LuggageTransport').then(mod('LuggageTransport')),
    { ssr: false },
  ),
  microphone: dynamic(() => import('Components/widgets/icons/Microphone').then(mod('Microphone')), {
    ssr: false,
  }),
  mixable: dynamic(() => import('Components/widgets/icons/Mixable').then(mod('Mixable')), {
    ssr: false,
  }),
  messenger: dynamic(() => import('Components/widgets/icons/Messenger').then(mod('Messenger')), {
    ssr: false,
  }),
  mobileapp: dynamic(() => import('Components/widgets/icons/Mobileapp').then(mod('Mobileapp')), {
    ssr: false,
  }),
  moon: dynamic(() => import('Components/widgets/icons/Moon').then(mod('Moon')), {
    ssr: false,
  }),
  overflowingpool: dynamic(
    () => import('Components/widgets/icons/Overflowingpool').then(mod('Overflowingpool')),
    { ssr: false },
  ),
  peoplebaby: dynamic(() => import('Components/widgets/icons/PeopleBaby').then(mod('PeopleBaby')), {
    ssr: false,
  }),
  pinroom: dynamic(() => import('Components/widgets/icons/PinRoom').then(mod('PinRoom')), {
    ssr: false,
  }),
  pinroomhighlight: dynamic(
    () => import('Components/widgets/icons/PinRoomHighlight').then(mod('PinRoomHighlight')),
    { ssr: false },
  ),
  reducedCapacity: dynamic(
    () => import('Components/widgets/icons/ReducedCapacity').then(mod('ReducedCapacity')),
    { ssr: false },
  ),
  repartitionAdultExp: dynamic(
    () => import('Components/widgets/icons/RepartitionAdultExp').then(mod('RepartitionAdultExp')),
    { ssr: false },
  ),
  repartitionBabyExp: dynamic(
    () => import('Components/widgets/icons/RepartitionBabyExp').then(mod('RepartitionBabyExp')),
    { ssr: false },
  ),
  repartitionChildExp: dynamic(
    () => import('Components/widgets/icons/RepartitionChildExp').then(mod('RepartitionChildExp')),
    { ssr: false },
  ),
  resortHouse: dynamic(
    () => import('Components/widgets/icons/ResortHouse').then(mod('ResortHouse')),
    { ssr: false },
  ),
  resortsAdults: dynamic(
    () => import('Components/widgets/icons/ResortsAdults').then(mod('ResortsAdults')),
    { ssr: false },
  ),
  sea: dynamic(() => import('Components/widgets/icons/Sea').then(mod('Sea')), {
    ssr: false,
  }),
  socialDistancing: dynamic(
    () => import('Components/widgets/icons/SocialDistancing').then(mod('SocialDistancing')),
    { ssr: false },
  ),
  sponsorship: dynamic(
    () => import('Components/widgets/icons/Sponsorship').then(mod('Sponsorship')),
    { ssr: false },
  ),
  sport_leisure_and_relaxation: dynamic(
    () =>
      import('Components/widgets/icons/SportLeisureAndRelaxation').then(
        mod('SportLeisureAndRelaxation'),
      ),
    { ssr: false },
  ),
  sun: dynamic(() => import('Components/widgets/icons/Sun').then(mod('Sun')), {
    ssr: false,
  }),
  trail: dynamic(() => import('Components/widgets/icons/Trail').then(mod('Trail')), {
    ssr: false,
  }),
  train: dynamic(() => import('Components/widgets/icons/Train').then(mod('Train')), {
    ssr: false,
  }),
  usertalk: dynamic(() => import('Components/widgets/icons/UserTalk').then(mod('UserTalk')), {
    ssr: false,
  }),
  vkontakte: dynamic(() => import('Components/widgets/icons/Vkontakte').then(mod('Vkontakte')), {
    ssr: false,
  }),
  wechatPayment: dynamic(
    () => import('Components/widgets/icons/WechatPayment').then(mod('WechatPayment')),
    { ssr: false },
  ),
  weibo: dynamic(() => import('Components/widgets/icons/Weibo').then(mod('Weibo')), {
    ssr: false,
  }),
  wellness: dynamic(() => import('Components/widgets/icons/Wellness').then(mod('Wellness')), {
    ssr: false,
  }),
  wenc: dynamic(() => import('Components/widgets/icons/Wenc').then(mod('Wenc')), {
    ssr: false,
  }),
  youtube: dynamic(() => import('Components/widgets/icons/Youtube').then(mod('Youtube')), {
    ssr: false,
  }),
};
